<template>
  <div id='registration-from' class="registration-from">
    <div v-if="loader || !regRulesAndTerms" class="group-data-loader">
      <spinner/>
    </div>
    <div v-else>
      <div class="registration-from_header">Завершение регистрации</div>
      <!-- <div>
        <div class="field-label">Придумайте логин для регистрации</div>
        <text-box requred
          :pattern="loginRegex"
          :min-length="regRulesAndTerms.loginMinLength"
          :max-length="regRulesAndTerms.loginMaxLength"
          v-model="regData.userName"
        />
      </div> -->
      <!-- <div>
        <div class="field-label">Email адрес</div>
        <text-box
          type='email'
          :min-length="regRulesAndTerms.emailMinLength"
          :max-length="regRulesAndTerms.emailMaxLength"
          requred
          :disabled="true"
          v-model="regData.email"
        />
      </div> -->
      <div>
        <div class="field-label">Email адрес</div>
        <text-box
          type='email'
          :disabled="true"
          :value="email"
        />
      </div>
      <div>
        <div class="field-label">Придумайте пароль</div>
        <text-box requred
          :min-legnth="regRulesAndTerms.passwordMinLength"
          :max-length="regRulesAndTerms.passwordMaxLength"
          type='password'
          v-model="regData.password"
          @input="checkPasswordStrength"
        />
      </div>
      <!-- Визуальный индикатор сложности -->
      <div class="strength-meter" v-if="regData.password">
        <div class="bar" :class="currentLevel.toLowerCase()"></div>
        <p class="status-text">Уровень: <strong>{{ currentLevel }}</strong></p>
        <p class="hint-text" v-if="currentHint">{{ currentHint }}</p>
      </div>

      <div>
        <div class="field-label">Повторите пароль</div>
        <text-box requred
          :min-legnth="regRulesAndTerms.passwordMinLength"
          :max-length="regRulesAndTerms.passwordMaxLength"
          type='password'
          v-model="regData.confirmPassword"
        />
      </div>
      
      <div>
        <div class="field-label">Дата рождения</div>
        <DatePickerBox
          requred
          placeholder="введите дату рождения"
          :min-value="regRulesAndTerms.minYearOfBirth+'-01-01'"
          v-model="regData.dateOfBirth"
          @validation="isValidDateOfBirth=$event"
        />
      </div>
      <div>
        <div class="field-label">Фамилия</div>
        <text-box requred
          :pattern="getRegex(regRulesAndTerms.nameFieldsPattern)"
          :min-length="regRulesAndTerms.nameFieldMinLength"
          :max-length="regRulesAndTerms.lastNameMaxLength"
          v-model="regData.lastName"
          @validation="isValidLastName=$event"
        />
      </div>
      <div>
        <div class="field-label">Имя</div>
        <text-box requred
          :pattern="getRegex(regRulesAndTerms.nameFieldsPattern)"
          :min-length="regRulesAndTerms.nameFieldMinLength"
          :max-length="regRulesAndTerms.firstNameMaxLength"
          v-model="regData.firstName"
          @validation="isValidFirstName=$event"
        />
      </div>
      <div>
        <div class="field-label">Отчество (при наличии)</div>
        <text-box
          :pattern="getRegex(regRulesAndTerms.nameFieldsPattern)"
          :min-length="regRulesAndTerms.nameFieldMinLength"
          :max-length="regRulesAndTerms.middleNameMaxLength"
          v-model="regData.middleName"
          @validation="isValidMiddleName=$event"
        />
      </div>
      <hr>
      <div class="control-questions">
        <h2>Контрольные вопросы</h2>
        <div class="control-question"
          v-for="(item, index) in controlQuestions"
          :key="index"
          :class="{'required': (index+1) <= regRulesAndTerms.minControlQuestionsToUserReg}"
          >
          <div class="control-question_label">
            <span>Контрольный вопрос {{index+1}}</span>
            <span v-if="(index+1) <= regRulesAndTerms.minControlQuestionsToUserReg"> (требуется)</span>
            <button
              v-if="(index+1) > regRulesAndTerms.minControlQuestionsToUserReg"
              class="control-question__close-btn"
              @click="removeControlQuestion(index)"
              aria-label="Удалить"
              title="Удалить">&times;</button>
          </div>
          <text-box
            :title="'Текст контрольного вопроса № ' + (index + 1)"
            :min-length="regRulesAndTerms.controlQuestionAnswerMinLength"
            :max-length="regRulesAndTerms.controlQuestionAnswerMaxLength"
            v-model="item.question"
            :required="(index+1) <= regRulesAndTerms.minControlQuestionsToUserReg"
          />
          <div class="control-question-answer_label">Ответ на вопрос</div>
          <text-box
            :title="'Текст ответа на контрольный вопрос № ' + (index + 1)"
            :min-length="regRulesAndTerms.controlQuestionAnswerMinLength"
            :max-length="regRulesAndTerms.controlQuestionAnswerMaxLength"
            v-model="item.answer"
            :required="(index+1) <= regRulesAndTerms.minControlQuestionsToUserReg"
          />
        </div>
        <div>
          <button v-if="controlQuestions && controlQuestions.length < 5"
            type="button"
            class="link align-right"
            aria-label="Добавить"
            @click="addControlQuestionClick">Добавить</button>
        </div>
      </div>
      <hr>
      <ErrorAlert v-if="errorMessage && errorMessage.length" :message="errorMessage" />
      <div class="button-container">
        <button
          :disabled="userRegLoader || !isValidRegData"
          type="button"
          class="btn blue"
          @click="completeRegistration"><spinner v-if="userRegLoader"/>Продолжить</button>
      </div>
      <div class="notice-block">
        <!-- Нажимая продолжить вы соглашаетесь ... -->
        <UserRegNotice />
      </div>
    </div>
  </div>
</template>

<script>

export default {
  components: {
  },
  props: {
    regRulesAndTerms: null,
    email: {
      type: String,
      required: true,
      default: ''
    },
    userId: {
      type: String,
      required: true,
      default: ''
    },
    verifyingCode: {
      type: String,
      required: true,
      default: ''
    },
    registrationCode: {
      type: String,
      required: true,
      default: ''
    }
  },
  data() {
    return {
      loader: false,
      errorMessage: '',
      controlQuestions: [],
      userRegLoader: false,
      regData: {
        // userName: '',
        email: '',
        password: '',
        confirmPassword: '',
        lastName: '',
        firstName: '',
        middleName: '',
        dateOfBirth: '',

        controlQuestion1: null,
        controlQuestion2: null,
        controlQuestion3: null,
        controlQuestion4: null,
        controlQuestion5: null,

        userId: '',
        verifyingCode: '',
        registrationSid: '',
      },
      // for password
      currentLevel: 'None',
      currentHint: '',
      isValidPassword: false,
      isValidFirstName: false,
      isValidLastName: false,
      isValidMiddleName: false,
      isValidDateOfBirth: false,

    }
  },
  computed: {
    loginRegex() {
      return this.regRulesAndTerms.loginAllowedSymbolsRegex.replace(/^^\^|\$$/g, '');
    },
    isValidRegData() {
      const result = this.regData &&
        this.isValidPassword &&
        this.regData.password === this.regData.confirmPassword &&
        this.isValidFirstName &&
        this.isValidLastName &&
        this.isValidMiddleName &&
        this.isValidDateOfBirth;
      // console.log('isValidRegData:' + result);
      return result;
      // return true;
    },
    passwordLevels() {
      return this.regRulesAndTerms.passwordLevels || [];
    }
  },
  methods: {
    checkPasswordStrength() {
      if (!this.regData.password || !this.regData.password.length) {
        this.currentLevel = 'None';
        this.currentHint = '';
        return;
      }

      // Ищем первый уровень, которому соответствует пароль
      const matchedLevel = this.passwordLevels.find(level => {
        // Создаем регулярное выражение из строки, пришедшей с бэкенда
        const regex = new RegExp(level.regexPattern);
        return regex.test(this.regData.password);
      });

      if (matchedLevel) {
        this.currentLevel = matchedLevel.name;
        this.currentHint = matchedLevel.description;
        this.isValidPassword = true;
      } else {
        this.currentLevel = 'Недостаточно надежный';
        // Выводим подсказку от минимального уровня (Low), так как пароль не прошел даже его
        const lowLevel = this.passwordLevels.find(l => l.name === 'Low');
        this.currentHint = lowLevel ? lowLevel.description : '';
      }
    },
    addControlQuestionClick() {
      this.controlQuestions.push({
        question: '',
        answer: ''
      });
    },
    removeControlQuestion(index) {
      this.controlQuestions.splice(index, 1);
    },
    getRegex(value) {
      // NameFieldsPattern
      if (!value || !value.length) return ''
      return value.replace(/^^\^|\$$/g, '');
    },
    writeContolQuestions() {
      this.regData.controlQuestion1 = null;
      this.regData.controlQuestion2 = null;
      this.regData.controlQuestion3 = null;
      this.regData.controlQuestion4 = null;
      this.regData.controlQuestion5 = null;

      if (!this.controlQuestions || !this.controlQuestions.length)
        return;

      if (this.controlQuestions.length > 0) {
        this.regData.controlQuestion1 = this.controlQuestions[0];
      }
      if (this.controlQuestions.length > 1) {
        this.regData.controlQuestion2 = this.controlQuestions[1];
      }
      if (this.controlQuestions.length > 2) {
        this.regData.controlQuestion3 = this.controlQuestions[2];
      }
      if (this.controlQuestions.length > 3) {
        this.regData.controlQuestion4 = this.controlQuestions[3];
      }
      if (this.controlQuestions.length > 4) {
        this.regData.controlQuestion5 = this.controlQuestions[4];
      }
    },
    completeRegistration() {
      this.loader = true;
      this.errorMessage = '';
      this.writeContolQuestions();
      this.regData.userId = this.userId;
      this.regData.email = this.email;
      this.regData.verifyingCode = this.verifyingCode;
      this.regData.registrationSid = this.registrationSid;
      
      const payload = this.regData;
      
      this.$http.post(`${this.$host.IdentityServiceApi}/ConfirmUserReg`, payload)
      .then((response) => {
        this.loader = false;
        // Учётная запись успешно создана! Теперь Вы можете выполнить Вход.
        // (link) войти
        this.$root.$on('onAuthenticated', response);
        window.location.href = '/profile';
      })
      .catch((e) => {
        this.loader = false;
        if (e.status)
          this.errorMessage = `${e.status}: ${e.statusText}`;
        // проверяем наличие данных в теле ответа
        if (e.body) {
          const body = e.body;
          if (e.body.message) {
            this.errorMessage = e.body.message;
            console.log(e.body.message);
          }
          else if (body.title && body.title.length) {
            this.errorMessage = body.title;
          }
          // проверяем детали ошибки
          if (body.errors) {
            // 1. Получаем все массивы из объекта errors, объединяем в один массив и сшиваем через перенос строки
            const errorDetail = Object.values(body.errors).flat().join('\n');
            if (errorDetail.length) this.errorMessage = errorDetail;
          }
        }
        if (!this.errorMessage || !this.errorMessage.length) {
          this.errorMessage = 'Ошибка. Повторите попытку позже.';
          console.log('Unexpected error!');
        }
      });
    }
  },
  created() {
    if (this.regRulesAndTerms && this.regRulesAndTerms.minControlQuestionsToUserReg) {
      for (let n = 0; n < this.regRulesAndTerms.minControlQuestionsToUserReg; n++) {
        this.addControlQuestionClick();
      }
    }
  }
}
</script>

<style src='@/assets/css/password-strength-meter.css'>
</style>

<style scoped>
.registration-from_header {
  font-size: 1.5em;
  margin-bottom: 0.83em;
  text-align: center;
  font-weight: bold;
}
.registration-from {
  /* min-width: 30rem; */
  width: 30rem;
  max-width: calc(100% - 2rem);
  margin-left: auto;
  margin-right: auto;
  padding: 1rem;
}
.field-label {
  margin-bottom: 0.25rem;
}
.button-container {
  margin-top: 2rem;
}

@media only screen and (max-width: 800px) {
  .registration-from {
    /* min-width: auto; */
    width: auto;
    max-width: calc(30rem);
  }
}
.control-question__close-btn {
  background: none;
  border: none;
  font-size: 22px;
  line-height: 1;
  color: #94a3b8;
  cursor: pointer;
  padding: 0 4px;
  display: block;
  margin-left: auto;
  width: auto;
  margin-right: 0;
  transition: color 0.2s ease;
}
.control-question_label {
  display: flex;
  padding-top: 1rem;
  padding-bottom: 0.5rem;
}
.control-question-answer_label {
  padding-bottom: 0.5rem;
}
.control-question__close-btn:hover {
  color: #475569; /* Смена цвета при наведении */
}

</style>